import React from 'react';
import './Healthcare.css';

import Icon from '../../../components/Icon/Icon';

const healthcare = ( props ) => (
	<section id="Healthcare">
		<h2>Healthcare</h2>
		<div className="section">
			<Icon icon="benefits.doctor" gradient="vertical" title="Doctor" />
			<div className="inner-section">
				<p>
					Medical insurance is through Cigna. Vision coverage is also through Cigna and is available on its own or as an optional add-on to the medical plan. <br />Find more information at: <a href="http://mycigna.com" target="_blank" rel="noopener noreferrer">mycigna.com</a>
				</p>
				<p>
					Dental insurance is through Delta Dental. <br />Find more information at: <a href="http://deltadentalva.com/subscribers.aspx" target="_blank" rel="noopener noreferrer">deltadentalva.com/subscribers.aspx</a>
				</p>
				<hr className="horizontal" />
			</div>
		</div>
	</section>
);

export default healthcare;



// WEBPACK FOOTER //
// ./src/pages/Benefits/Healthcare/Healthcare.js